import React from 'react';
import PropType from 'prop-types';
import './DragToRotateTooltip.css';
import { isMobileDevice } from 'web-store-modules/packages/obsess-device-detector';
import { BaseImage } from 'web-store-modules/packages/web-store-ui-library';

const isMobile = isMobileDevice();

const dragTooltipStyle = {
    position: 'absolute',
    zIndex: '1',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -30%)',
};

/**
 * Tooltip that explains how to navigate stores.
 * Will render on center of screen by default.
 * */
function DragToRotateTooltip(props) {
    const { isTemplate, image, imgStyle, backImg, classes } = props;
    return (
        <div id="drag-tooltip-container" className="flex-center" style={isTemplate ? null : dragTooltipStyle}>
            {backImg && <BaseImage
                className="under-img"
                src={backImg}
            />}
            <BaseImage
                className={'tooltip-img ' + (backImg ? ' over-img ' : '') + (classes ? classes : '')}
                src={image}
                style={imgStyle}
            />
        </div>
    );
}

DragToRotateTooltip.propTypes = {
    isTemplate: PropType.bool,
    image: PropType.string,
    imgStyle: PropType.object,
};

DragToRotateTooltip.defaultProps = {
    isTemplate: false,
};

export default DragToRotateTooltip;
